@use '../../common/colors.scss' as colors;

.autopay-wrapper {
  display: flex;
  align-items: center;
  margin: 20px 0;
  font-size: 0.85em;
  color: colors.$label;
}

.autopay-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-right: 15px;
  margin-bottom: 0;
  max-width: 100%;
  font-weight: 400;
  display: inline-block;
}

.autopay-slider {
  position: absolute;
  left: 0;
  cursor: pointer;
  height: 12px;
  width: 40px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    margin-top: -4px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;
    content: '\00D7';
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: colors.$white;
    color: #000;
    box-shadow: 0px 1px 2px 1px colors.$label;
  }
}

.autopay-checked .autopay-slider {
  background-color: rgba(46, 165, 154, 0.4);
  border-radius: 34px;

  &::before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
    content: '\2713';
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: colors.$uplift-green;
  }
}

.autopay-switch.autopay-checked .autopay-slider {
  background-color: rgba(46, 165, 154, 0.4);
  border-radius: 34px;

  &::before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
    content: '\2713';
    display: flex;
    justify-content: center;
    align-items: center;
    color: colors.$white;
    background-color: colors.$uplift-green;
  }
}

// Flexpay
:global(.flexpay) {
  .autopay-switch.autopay-checked .autopay-slider {
    background-color: #e3f1f7;

    &::before {
      background-color: colors.$flexpay-link;
    }
  }
}
